import React, { useState } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { clearImpersonationState, getImpersonationState } from '../../helpers/impersonation';
import { AdminAppService } from '../../services/admin/adminAppService';

/**
 * Barra fija que avisa que el admin de sitio está navegando como otro usuario
 * y ofrece volver a su cuenta. Se muestra solo si el usuario logueado es el
 * impersonado que quedó registrado en el estado local.
 */
const ImpersonationBanner: React.FC = () => {
  const { user } = useAuth();
  const [saliendo, setSaliendo] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const state = getImpersonationState();
  if (!state || !user) return null;
  if (state.target.userId !== user.id) {
    // Estado huérfano (ej: el admin volvió a loguearse a mano): se descarta.
    if (user.id === state.adminUserId) clearImpersonationState();
    return null;
  }

  const volver = async () => {
    setSaliendo(true);
    setError(null);
    try {
      await AdminAppService.terminarImpersonacion();
    } catch (e) {
      setError(e instanceof Error ? e.message : 'No se pudo volver a tu cuenta');
      setSaliendo(false);
    }
  };

  return (
    <div
      role="status"
      data-testid="impersonation-banner"
      className="sticky top-0 z-[60] flex flex-wrap items-center justify-center gap-x-3 gap-y-1 bg-danger px-4 py-2 text-sm text-paper"
    >
      <span>
        👤 Estás viendo la app como <strong>{state.target.label}</strong>
        {state.target.email && state.target.label !== state.target.email ? ` (${state.target.email})` : ''}
        {' '}en <strong>{state.empresa.nombre}</strong>
      </span>
      <button
        type="button"
        onClick={volver}
        disabled={saliendo}
        className="rounded-md border border-paper/60 px-3 py-1 font-medium transition-colors hover:bg-paper/15 disabled:opacity-60"
      >
        {saliendo ? 'Volviendo…' : 'Volver a mi cuenta'}
      </button>
      {error && <span className="w-full text-center text-xs">{error}</span>}
    </div>
  );
};

export default ImpersonationBanner;
